export const EXSBMEASURE_CREATE_RESET = 'EXSBMEASURE_CREATE_RESET'
export const EXSBMEASURE_CREATE_SET_CREATED = 'EXSBMEASURE_CREATE_SET_CREATED'
export const EXSBMEASURE_CREATE_SET_ERROR = 'EXSBMEASURE_CREATE_SET_ERROR'
export const EXSBMEASURE_CREATE_SET_VIOLATIONS = 'EXSBMEASURE_CREATE_SET_VIOLATIONS'
export const EXSBMEASURE_CREATE_TOGGLE_LOADING = 'EXSBMEASURE_CREATE_TOGGLE_LOADING'
